import React, { Component,Fragment } from 'react';

import iconProductService from './image/product-service.svg';
import iconProductHardware from './image/product-hardware.svg';
import iconProductStore from './image/product-store.svg';
import slogan from './image/slogan-product.svg';
import banner from './image/banner-product.svg';
import banner_mengduo from './image/mengduo/product.svg'

import './Product.css';

export  default class Solution extends Component {
  constructor(props){
    super(props)
    this.state={
      data:[{
        title:'[智量]拍照量体服务',
        sub:'无处不在的量体服务',
        intro:'正常衣着,环境的情况下通过手机拍照,即可获取准确的身材数据;极大的量体服务效率及范围,帮你构建新的核心竞争力',
        img:require('./image/paizhao.svg')
        },
        {
        title:'[智量]智能量体终端',
        sub:'自带营销功能的量体设备',
        intro:'创新人体数据采集终端,可以极大的节省硬件投入成本.通过硬件+软件的创新结合,帮你快速进入新零售时代',
        img:require('./image/zhineng.svg')
        },
        {
        title:'[智量]智能量体终端',
        sub:'自带营销功能的量体设备',
        intro:'创新人体数据采集终端,可以极大的节省硬件投入成本.通过硬件+软件的创新结合,帮你快速进入新零售时代',
        img:require('./image/zaixiandingzhi.svg')
        }]
    }
  }

  componentDidMount(){
    if(/Android|webOS|iPhone|iPod|pad|ipad/i.test(navigator.userAgent)) {
      // debugger
      this.setState({
        isMobile:!this.state.isMobile
      })
    } 
}

    render(){
      return(
        <Fragment>
          {this.state.isMobile&&
            <Fragment>
              <div className="tag-container" style={{marginTop:"6rem"}}>
                {
                  this.state.data.map((item,index)=>{
                    return (
                      <div style={{borderBottom:(index===2?"0":"solid 0.01rem #c9c9c9")}} key={index} className="box" >
                        <img  style={{width:"6rem",margin:"0.5rem"}} src={item.img} className="icon"/>
                        <div style={{textAlign:"left"}} className="intro">
                          <div className="title02-1">{item.title}</div>
                          <div  style={{color:"rgb(68,126,235)"}} className="intro02-1">{item.sub}</div>
                          <div style={{color:"rgb(153,166,188)"}} className="intro02-1">{item.intro}</div>
                        </div>
                      </div>  
                    );
                  })
                }
              </div>
            </Fragment>
          }
          {!this.state.isMobile&&
          <Fragment>
            <div className={global.constants.channel==="mengduo"? "banner_mengduo":"banner"}>
              <div className="banner--content">
                <img src={slogan} alt="slogan" />
                <img src={global.constants.channel==="mengduo"? banner_mengduo:banner} alt="" />
              </div>
            </div>
            <div className="Product--conent content-area">
              <div className="Product--item">
                <img
                  className="Product--item__icon"
                  src={iconProductService}
                  alt="service"
                />
                <div className="Product--item__text">
                  <p className="Product--item__title">【智量】拍照量体小程序</p>
                  <p className="Product--item__subtitle">在移动设备上完成量体</p>
                  <p className="Product--item__desc">
                    【智量】以智能手机为终端，以小程序为载体，可以将任何一台智能手机变为量体终端，并进行精确量体。
                  </p>
                  <p className="Product--item__desc">
                    专门为移动设备优化的算法，在提供强大识别能力的同时，智能平衡手机计算资源的使用，无需担心设备性能不足。
                  </p>
                  <p className="Product--item__desc">
                    【智量】同时提供多种技术接入方式，灵活适用各类业务场景
                  </p>
                </div>
              </div>
              <div className="Product--item">
                <img
                  className="Product--item__icon"
                  src={iconProductHardware}
                  alt="store"
                />
                <div className="Product--item__text">
                  <p className="Product--item__title">【智量】智能量体终端</p>
                  <p className="Product--item__subtitle">自带营销功能的量体设备</p>
                  <p className="Product--item__desc">
                  【智量终端】是为线下定制店打造的智能终端，集电子画册、视频播放、量体服务、健康检测等功能与一体。以客户自助的方式，实现了传统量体服务的替代。
                  </p>
                  <p className="Product--item__desc">
                    60cm X 45cm的小巧体积，适合布放于零售店的各个位置。
                  </p>
                  <p className="Product--item__desc">
                    【智量】同时提供外观及VI定制服务，满足企业的个性化需求。
                  </p>
                </div>
              </div>
              <div className="Product--item">
                <img
                  className="Product--item__icon"
                  src={iconProductStore}
                  alt="store"
                />
                <div className="Product--item__text">
                  <p className="Product--item__title">【智量】在线定制商城</p>
                  <p className="Product--item__subtitle">帮你轻松搭建定制商城</p>
                  <p className="Product--item__desc">
                    提供多样的店铺模版，可以快速搭建出符合你品牌格调的线上定制商城
                  </p>
                  <p className="Product--item__desc">
                    从3D在线定制、智能量体到客户精准营销，完整满足你的各种经营场景
                  </p>
                  <p className="Product--item__desc">
                    【智量】提供安全可靠的技术支持，你只需专注发展你的业务
                  </p>
                </div>
              </div>
            </div>
          </Fragment>
          }
        </Fragment>
      )
    }
  }



// WEBPACK FOOTER //
// ./src/Product.js